/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './navmenu.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i3 from '@angular/material';
import * as i4 from '@angular/flex-layout/flexbox/api/class';
import * as i5 from '@angular/flex-layout/media-query/media-monitor';
import * as i6 from '@angular/router';
import * as i7 from '@angular/common';
import * as i8 from '../../../../app/components/navmenu/navmenu.component';
const styles_NavMenuComponent:any[] = [i0.styles];
export const RenderType_NavMenuComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_NavMenuComponent,data:{}});
export function View_NavMenuComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),65,'md-nav-list',
      [['class','main-nav mat-nav-list'],['role','list']],(null as any),(null as any),
      (null as any),i2.View_MdList_0,i2.RenderType_MdList)),i1.ɵdid(16384,(null as any),
      0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
      (null as any)),i1.ɵdid(49152,(null as any),0,i3.MdList,([] as any[]),(null as any),
      (null as any)),i1.ɵdid(16384,(null as any),0,i3.MdNavListCssMatStyler,([] as any[]),
      (null as any),(null as any)),i1.ɵdid(933888,(null as any),0,i4.ClassDirective,
      [i5.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
          i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted(0,
      ['\n    '])),(_l()(),i1.ɵeld(0,(null as any),0,10,'a',[['class','mat-list-item'],
      ['md-list-item',''],['role','listitem']],[[1,'target',0],[8,'href',4]],[[(null as any),
      'click'],[(null as any),'focus'],[(null as any),'blur']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,7).onClick($event.button,$event.ctrlKey,$event.metaKey,
          $event.shiftKey)) !== false);
      ad = (pd_0 && ad);
    }
    if (('focus' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,9)._handleFocus()) !== false);
      ad = (pd_1 && ad);
    }
    if (('blur' === en)) {
      const pd_2:any = ((<any>i1.ɵnov(_v,9)._handleBlur()) !== false);
      ad = (pd_2 && ad);
    }
    return ad;
  },i2.View_MdListItem_0,i2.RenderType_MdListItem)),i1.ɵdid(671744,(null as any),0,
      i6.RouterLinkWithHref,[i6.Router,i6.ActivatedRoute,i7.LocationStrategy],{routerLink:[0,
          'routerLink']},(null as any)),i1.ɵpad(1),i1.ɵdid(1097728,(null as any),2,
      i3.MdListItem,[i1.Renderer2,i1.ElementRef,[2,i3.MdList],[2,i3.MdNavListCssMatStyler]],
      (null as any),(null as any)),i1.ɵqud(603979776,1,{_lines:1}),i1.ɵqud(335544320,
      2,{_hasAvatar:0}),(_l()(),i1.ɵted(2,['\n        '])),(_l()(),i1.ɵeld(0,(null as any),
      2,2,'md-icon',[['class','mat-icon'],['role','img'],['svgIcon','home']],(null as any),
      (null as any),(null as any),i2.View_MdIcon_0,i2.RenderType_MdIcon)),i1.ɵdid(16384,
      (null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
      (null as any),(null as any)),i1.ɵdid(638976,(null as any),0,i3.MdIcon,[i1.Renderer2,
      i1.ElementRef,i3.MdIconRegistry,[8,(null as any)]],{svgIcon:[0,'svgIcon']},(null as any)),
      (_l()(),i1.ɵted(2,[' \n        Home\n    '])),(_l()(),i1.ɵted(0,['\n    '])),
      (_l()(),i1.ɵeld(0,(null as any),0,10,'a',[['class','mat-list-item'],['md-list-item',
          ''],['role','listitem']],[[1,'target',0],[8,'href',4]],[[(null as any),'click'],
          [(null as any),'focus'],[(null as any),'blur']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,19).onClick($event.button,$event.ctrlKey,
              $event.metaKey,$event.shiftKey)) !== false);
          ad = (pd_0 && ad);
        }
        if (('focus' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,21)._handleFocus()) !== false);
          ad = (pd_1 && ad);
        }
        if (('blur' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,21)._handleBlur()) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },i2.View_MdListItem_0,i2.RenderType_MdListItem)),i1.ɵdid(671744,(null as any),
          0,i6.RouterLinkWithHref,[i6.Router,i6.ActivatedRoute,i7.LocationStrategy],
          {routerLink:[0,'routerLink']},(null as any)),i1.ɵpad(1),i1.ɵdid(1097728,
          (null as any),2,i3.MdListItem,[i1.Renderer2,i1.ElementRef,[2,i3.MdList],
              [2,i3.MdNavListCssMatStyler]],(null as any),(null as any)),i1.ɵqud(603979776,
          3,{_lines:1}),i1.ɵqud(335544320,4,{_hasAvatar:0}),(_l()(),i1.ɵted(2,['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),2,2,'md-icon',[['class','mat-icon'],['role',
          'img'],['svgIcon','view-sequential']],(null as any),(null as any),(null as any),
          i2.View_MdIcon_0,i2.RenderType_MdIcon)),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,
          [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(638976,(null as any),0,i3.MdIcon,[i1.Renderer2,i1.ElementRef,i3.MdIconRegistry,
          [8,(null as any)]],{svgIcon:[0,'svgIcon']},(null as any)),(_l()(),i1.ɵted(2,
          [' \n        Product List\n    '])),(_l()(),i1.ɵted(0,['\n    '])),(_l()(),
          i1.ɵeld(0,(null as any),0,10,'a',[['class','mat-list-item'],['md-list-item',
              ''],['role','listitem']],[[1,'target',0],[8,'href',4]],[[(null as any),
              'click'],[(null as any),'focus'],[(null as any),'blur']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,31).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            if (('focus' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,33)._handleFocus()) !== false);
              ad = (pd_1 && ad);
            }
            if (('blur' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,33)._handleBlur()) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },i2.View_MdListItem_0,i2.RenderType_MdListItem)),i1.ɵdid(671744,(null as any),
          0,i6.RouterLinkWithHref,[i6.Router,i6.ActivatedRoute,i7.LocationStrategy],
          {routerLink:[0,'routerLink']},(null as any)),i1.ɵpad(1),i1.ɵdid(1097728,
          (null as any),2,i3.MdListItem,[i1.Renderer2,i1.ElementRef,[2,i3.MdList],
              [2,i3.MdNavListCssMatStyler]],(null as any),(null as any)),i1.ɵqud(603979776,
          5,{_lines:1}),i1.ɵqud(335544320,6,{_hasAvatar:0}),(_l()(),i1.ɵted(2,['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),2,2,'md-icon',[['class','mat-icon'],['role',
          'img'],['svgIcon','view-list']],(null as any),(null as any),(null as any),
          i2.View_MdIcon_0,i2.RenderType_MdIcon)),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,
          [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(638976,(null as any),0,i3.MdIcon,[i1.Renderer2,i1.ElementRef,i3.MdIconRegistry,
          [8,(null as any)]],{svgIcon:[0,'svgIcon']},(null as any)),(_l()(),i1.ɵted(2,
          [' \n        Version List\n    '])),(_l()(),i1.ɵted(0,['\n    '])),(_l()(),
          i1.ɵeld(0,(null as any),0,10,'a',[['class','mat-list-item'],['md-list-item',
              ''],['role','listitem']],[[1,'target',0],[8,'href',4]],[[(null as any),
              'click'],[(null as any),'focus'],[(null as any),'blur']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,43).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            if (('focus' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,45)._handleFocus()) !== false);
              ad = (pd_1 && ad);
            }
            if (('blur' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,45)._handleBlur()) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },i2.View_MdListItem_0,i2.RenderType_MdListItem)),i1.ɵdid(671744,(null as any),
          0,i6.RouterLinkWithHref,[i6.Router,i6.ActivatedRoute,i7.LocationStrategy],
          {routerLink:[0,'routerLink']},(null as any)),i1.ɵpad(1),i1.ɵdid(1097728,
          (null as any),2,i3.MdListItem,[i1.Renderer2,i1.ElementRef,[2,i3.MdList],
              [2,i3.MdNavListCssMatStyler]],(null as any),(null as any)),i1.ɵqud(603979776,
          7,{_lines:1}),i1.ɵqud(335544320,8,{_hasAvatar:0}),(_l()(),i1.ɵted(2,['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),2,2,'md-icon',[['class','mat-icon'],['role',
          'img'],['svgIcon','plus-box']],(null as any),(null as any),(null as any),
          i2.View_MdIcon_0,i2.RenderType_MdIcon)),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,
          [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(638976,(null as any),0,i3.MdIcon,[i1.Renderer2,i1.ElementRef,i3.MdIconRegistry,
          [8,(null as any)]],{svgIcon:[0,'svgIcon']},(null as any)),(_l()(),i1.ɵted(2,
          [' \n        Add Product\n    '])),(_l()(),i1.ɵted(0,['\n    '])),(_l()(),
          i1.ɵeld(0,(null as any),0,10,'a',[['class','mat-list-item'],['md-list-item',
              ''],['role','listitem']],[[1,'target',0],[8,'href',4]],[[(null as any),
              'click'],[(null as any),'focus'],[(null as any),'blur']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,55).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            if (('focus' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,57)._handleFocus()) !== false);
              ad = (pd_1 && ad);
            }
            if (('blur' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,57)._handleBlur()) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },i2.View_MdListItem_0,i2.RenderType_MdListItem)),i1.ɵdid(671744,(null as any),
          0,i6.RouterLinkWithHref,[i6.Router,i6.ActivatedRoute,i7.LocationStrategy],
          {routerLink:[0,'routerLink']},(null as any)),i1.ɵpad(1),i1.ɵdid(1097728,
          (null as any),2,i3.MdListItem,[i1.Renderer2,i1.ElementRef,[2,i3.MdList],
              [2,i3.MdNavListCssMatStyler]],(null as any),(null as any)),i1.ɵqud(603979776,
          9,{_lines:1}),i1.ɵqud(335544320,10,{_hasAvatar:0}),(_l()(),i1.ɵted(2,['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),2,2,'md-icon',[['class','mat-icon'],['role',
          'img'],['svgIcon','file-plus']],(null as any),(null as any),(null as any),
          i2.View_MdIcon_0,i2.RenderType_MdIcon)),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,
          [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(638976,(null as any),0,i3.MdIcon,[i1.Renderer2,i1.ElementRef,i3.MdIconRegistry,
          [8,(null as any)]],{svgIcon:[0,'svgIcon']},(null as any)),(_l()(),i1.ɵted(2,
          [' \n        Add Version\n    '])),(_l()(),i1.ɵted(0,['\n'])),(_l()(),i1.ɵted((null as any),
          ['\n']))],(_ck,_v) => {
    const currVal_0:any = 'main-nav';
    _ck(_v,4,0,currVal_0);
    const currVal_3:any = _ck(_v,8,0,'/home');
    _ck(_v,7,0,currVal_3);
    const currVal_4:any = 'home';
    _ck(_v,15,0,currVal_4);
    const currVal_7:any = _ck(_v,20,0,'/products');
    _ck(_v,19,0,currVal_7);
    const currVal_8:any = 'view-sequential';
    _ck(_v,27,0,currVal_8);
    const currVal_11:any = _ck(_v,32,0,'/versions');
    _ck(_v,31,0,currVal_11);
    const currVal_12:any = 'view-list';
    _ck(_v,39,0,currVal_12);
    const currVal_15:any = _ck(_v,44,0,'/productedit');
    _ck(_v,43,0,currVal_15);
    const currVal_16:any = 'plus-box';
    _ck(_v,51,0,currVal_16);
    const currVal_19:any = _ck(_v,56,0,'/versionedit');
    _ck(_v,55,0,currVal_19);
    const currVal_20:any = 'file-plus';
    _ck(_v,63,0,currVal_20);
  },(_ck,_v) => {
    const currVal_1:any = i1.ɵnov(_v,7).target;
    const currVal_2:any = i1.ɵnov(_v,7).href;
    _ck(_v,6,0,currVal_1,currVal_2);
    const currVal_5:any = i1.ɵnov(_v,19).target;
    const currVal_6:any = i1.ɵnov(_v,19).href;
    _ck(_v,18,0,currVal_5,currVal_6);
    const currVal_9:any = i1.ɵnov(_v,31).target;
    const currVal_10:any = i1.ɵnov(_v,31).href;
    _ck(_v,30,0,currVal_9,currVal_10);
    const currVal_13:any = i1.ɵnov(_v,43).target;
    const currVal_14:any = i1.ɵnov(_v,43).href;
    _ck(_v,42,0,currVal_13,currVal_14);
    const currVal_17:any = i1.ɵnov(_v,55).target;
    const currVal_18:any = i1.ɵnov(_v,55).href;
    _ck(_v,54,0,currVal_17,currVal_18);
  });
}
export function View_NavMenuComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'nav-menu',([] as any[]),
      (null as any),(null as any),(null as any),View_NavMenuComponent_0,RenderType_NavMenuComponent)),
      i1.ɵdid(49152,(null as any),0,i8.NavMenuComponent,([] as any[]),(null as any),
          (null as any))],(null as any),(null as any));
}
export const NavMenuComponentNgFactory:i1.ComponentFactory<i8.NavMenuComponent> = i1.ɵccf('nav-menu',
    i8.NavMenuComponent,View_NavMenuComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./Client/$$_gendir/app/components/navmenu/navmenu.component.ngfactory.ts